import {Component, OnInit} from '@angular/core';
// import {PaymentInstructions} from '../confirmation/confirmation.component';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {SetPaymentStepAfripay} from '../../shared/map.actions';
import {Session} from 'src/app/interfaces/session-data';
import {GoogleAnalyticsService} from '../../../services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-processing',
  templateUrl: './processing.component.html',
  styleUrls: ['./processing.component.scss'],
})
export class ProcessingComponent implements OnInit {

  // loader
  loading: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;

  public wallet = {
    img: '',
    name: '',
    id: 0
  };

  mobile: boolean = false;

  // -- payment instructions

  paymentInstructionsEl: string = '';
  paymentInstructionsImg: string = '';

  // paymentInstructions: PaymentInstructions = {
  //   paymentInstructions: '',
  //   img: ''
  // };

  session: Session;

  headerColor: string = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private googleAnalyticsService: GoogleAnalyticsService) {
    router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        let nav = this.router.getCurrentNavigation();
        this.loading = false;
        if (nav.extras && nav.extras.state)
          this.wallet = nav.extras.state.wallet;
      });
  }

  ngOnInit(): void {
    this.session = (JSON.parse(sessionStorage.getItem('sessionData')) as Session);
    this.headerColor =
      this.session.sessionDisplayInformation.colorScheme.slice(0, this.session.sessionDisplayInformation.colorScheme.length - 1);


    this.store.dispatch(new SetPaymentStepAfripay("STEP_TWO"));
  }

  confirmWallet() {
    // this.googleAnalyticsService
    // .eventEmitter('checkout_progress', 'afripay', 'confirmed_wallet', this.wallet.name, 1);

    this.router.navigate(['confirmation'], { relativeTo: this.route.parent });
  }

  goBackToWallet() {
    // this.googleAnalyticsService
    // .eventEmitter('checkout_progress', 'afripay', 'cancelled_wallet', this.wallet.name, 1);

    this.router.navigate(['wallet'], { relativeTo: this.route.parent });
  }

}
